export default "__VITE_ASSET__2e835723__$_?nuxt_component=async__"